export function CopyrightFooter() {
  return (
    <footer className="w-full border-t border-violet-500/20 bg-[#0a0a0a]/95 backdrop-blur-xl mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
          {/* Copyright Notice */}
          <div className="flex items-center gap-2">
            <span className="font-mono">© 2025 FFOLLOWME OÜ</span>
            <span className="hidden md:inline">|</span>
            <span className="font-mono hidden md:inline">Reg: 16785919</span>
          </div>

          {/* Center Text */}
          <div className="text-center">
            <span className="text-violet-400">Nardium</span>
            <span className="mx-2">•</span>
            <span>Confidential & Proprietary</span>
          </div>

          {/* Location */}
          <div className="flex items-center gap-2">
            <span>Tallinn, Estonia</span>
            <span className="hidden md:inline">|</span>
            <span className="hidden md:inline">All Rights Reserved</span>
          </div>
        </div>

        {/* Mobile Registry Code */}
        <div className="md:hidden text-center mt-2 text-xs text-gray-600 font-mono">
          Registry: 16785919
        </div>
      </div>
    </footer>
  );
}
